import React, { useEffect, useState } from "react";
import swal from "@sweetalert/with-react";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
  Button,
  Col,
  Form,
  Row,
  Input,
  Label,
  InputGroupAddon,
  FormGroup,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import moment from "moment";
import ReactDatePicker from "../../ShortCutComponents/ReactDatePicker";
import Swal from "sweetalert2";
import Select from "react-select";
import { checkPermission } from "../../../../Helper";
import "./baseForms.css";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../../../../baseurl";
import "./myReactSelect.css";
import "react-datepicker/dist/react-datepicker.css";
import NumberFormat from "react-number-format";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Responseloader from "../../ShortCutComponents/ResponseLoader";
import tooltipText from "../../ShortCutComponents/tooltipText";
import { GetIp } from "../../ShortCutComponents/Get_ip";
import PurchasereceiptModal from "./purchasereceiptModal";

let companyId = localStorage.getItem("companyId");
let username = localStorage.getItem("username");
var token = localStorage.getItem("token");

export default function PartyOverview(props) {
  const [table, setTable] = useState({
    OverViewDataTable: [],
  });
  const [loadingResponse, setLoadingResponse] = useState(false);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [purchaseId, setPurchaseId] = useState(null);
  const [subInvLov, setSubInvLov] = useState([]);
  const [fSubInv, setFSubInv] = useState();
  const [fDate, setFDate] = useState("");
  const [tDate, setTDate] = useState("");

  useEffect(() => {
    const funCall = async (value) => {
      await asyncRollCheck(value);
    };
    funCall(0);
    getLovs();
  }, []);
  const addPropToggle = (row) => {
    setShowPurchaseModal(!showPurchaseModal);
    setPurchaseId(row?.PURCH_INVOICE_ID);
  };
  const asyncRollCheck = async (value) => {
    let pathname = "/branchTransferInvoicesOverview";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };
  // const sale_formater = (cell, row) => {
  //   const saleAmount = Number(cell) || 0;
  //   const purchaseAmount = Number(row.AMOUNT) || 0;

  //   const style = {
  //     color: saleAmount > purchaseAmount ? "red" : "inherit",
  //     fontWeight: saleAmount > purchaseAmount ? "600" : "normal",
  //   };

  //   return <span style={style}>{cell}</span>;
  // };

  const dueformatter = (cell, row) => {
    const amount = Number(cell) || 0;
    // Format with commas and 2 decimal places
    const formattedAmount = amount.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });

    return <span>{formattedAmount}</span>;
  };

  const getLovs = () => {
    let SubInvData = [];
    axios
      .post(
        `${baseurl}/lovs/getDynamicBranchLov`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then((response) => {
        let responseData = response.data.data;

        setSubInvLov(responseData);
        setLoadingResponse(false);
      })
      .catch((err) => {
        console.log(err);
        setLoadingResponse(false);
      });
  };
  const getData = (branchId) => {
    // var offSet, pageSize;
    setLoadingResponse(true);

      let sDate = fDate ? moment(fDate).format("YYYY-MM-DD") : null;
      let eDate = tDate ? moment(tDate).format("YYYY-MM-DD") : null;

    axios
      .post(
        `${baseurl}/masterData/getBranchTransferInvoices`,
        {
          branchId: branchId,
          fromDate: sDate,
          toDate: eDate,
          companyId: companyId,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then((res) => {
        setLoadingResponse(false);
        setTable({
          OverViewDataTable: res.data.data,
        });
      })
      .catch((err) => {
        console.log(err);
        setLoadingResponse(false);
      });
  };
const exportToExcel = () => {
  if (!table.OverViewDataTable || table.OverViewDataTable.length === 0) {
    swal({
      title: "No Data",
      text: "Export karne ke liye koi data available nahi hai",
      icon: "warning",
    });
    return;
  }

  const exportData = table.OverViewDataTable.map((row) => ({
    "Purchase No": row.DOCUMENT_NO,
    "Purchase Qty": row.received_Qty,
    "Purchase Amount": row.AMOUNT,
    "Purchase Date": row.purch_formatted_date,
    "Transfer Invoice No": row.inv_doc,
    "Transfer Qty": row.inv_total_qty,
    "Transfer Amount": row.inv_total_amount,
    "Transfer Date": row.inv_formatted_date,
    "From Branch": row.branch_desc,
    "To Branch": row.to_branch_desc,
    "Received Qty": row.received_Qty,
  }));

  const totalColumns = Object.keys(exportData[0]).length;

  // Filter values
  const branchLabel = fSubInv?.label || fSubInv?.value || "-- Not Selected --";
  const fromDateStr = fDate ? moment(fDate).format("DD-MMM-YYYY") : "N/A";
  const toDateStr = tDate ? moment(tDate).format("DD-MMM-YYYY") : "N/A";

  // Heading + Filter rows
  const headerRows = [
    ["Branch Transfer Invoices"],
    [
      `Filters : Branch  ${branchLabel}  -  From Date ${fromDateStr}  -  To Date ${toDateStr}`,
    ],
    [], // empty spacer row
  ];

  const worksheet = XLSX.utils.aoa_to_sheet(headerRows);

  // Add the actual table data right after the header rows
  XLSX.utils.sheet_add_json(worksheet, exportData, {
    origin: -1, // appends after existing rows
    skipHeader: false,
  });

  // Merge heading row across all columns
  worksheet["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: totalColumns - 1 } }, // Heading row
    { s: { r: 1, c: 0 }, e: { r: 1, c: totalColumns - 1 } }, // Filters row
  ];

  // Optional: column widths for better readability
  worksheet["!cols"] = Array(totalColumns).fill({ wch: 18 });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "BranchTransferInvoices");

  XLSX.writeFile(
    workbook,
    `Branch_Transfer_Invoices_${moment().format("YYYY-MM-DD")}.xlsx`
  );
};
const exportToPDF = () => {
  if (!table.OverViewDataTable || table.OverViewDataTable.length === 0) {
    swal({
      title: "No Data",
      text: "Export karne ke liye koi data available nahi hai",
      icon: "warning",
    });
    return;
  }

  const branchLabel = fSubInv?.label || fSubInv?.name || fSubInv?.text || "-- Not Selected --";
  const fromDateStr = fDate ? moment(fDate).format("DD-MMM-YYYY") : "N/A";
  const toDateStr = tDate ? moment(tDate).format("DD-MMM-YYYY") : "N/A";

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "pt",
    format: "a4",
  });

  const pageWidth = doc.internal.pageSize.getWidth();

  // Heading
  doc.setFontSize(14);
  doc.setFont(undefined, "bold");
  doc.text("Branch Transfer Invoices", pageWidth / 2, 30, { align: "center" });

  // Filters line
  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text(
    `Filters : Branch  ${branchLabel}  -  From Date ${fromDateStr}  -  To Date ${toDateStr}`,
    pageWidth / 2,
    48,
    { align: "center" }
  );

  const tableColumns = [
    "Purchase No",
    "Purchase Qty",
    "Purchase Amount",
    "Purchase Date",
    "Transfer Invoice No",
    "Transfer Qty",
    "Transfer Amount",
    "Transfer Date",
    "From Branch",
    "To Branch",
    "Received Qty",
  ];

  const tableRows = table.OverViewDataTable.map((row) => [
    row.DOCUMENT_NO ?? "",
    row.received_Qty ?? "",
    (Number(row.AMOUNT) || 0).toLocaleString("en-US"),
    row.purch_formatted_date ?? "",
    row.inv_doc ?? "",
    row.inv_total_qty ?? "",
    (Number(row.inv_total_amount) || 0).toLocaleString("en-US"),
    row.inv_formatted_date ?? "",
    row.branch_desc ?? "",
    row.to_branch_desc ?? "",
    row.received_Qty ?? "",
  ]);

  autoTable(doc, {
    head: [tableColumns],
    body: tableRows,
    startY: 60,
    styles: { fontSize: 8, cellPadding: 3 },
    headStyles: { fillColor: [41, 128, 185], textColor: 255, halign: "center" },
    bodyStyles: { halign: "center" },
    theme: "grid",
  });

  doc.save(`Branch_Transfer_Invoices_${moment().format("YYYY-MM-DD")}.pdf`);
};
  const redirectToForm = (row, type, attachment) => {
    props.history.push({
      pathname: "/DepartmentPlanSetup",
      state: {
        // rowData: row,
        id: row?.PURCH_INVOICE_ID,
        type,
        // attachment,
      },
    });
  };
  const getUserIp = async function () {
    let res = await GetIp();
    console.log(res);
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
  };
  const blocked = () => {
    swal({
      title: "This Module is not in Use",
      text: "operation should not be performed!",
      icon: "warning",
    });
  };
  const handleFromChangeOpen = (e) => {
    setFSubInv(e);
    // if (e) {
    //   getData(e?.id);
    // }
  };

  const setDelete = async (row) => {
    const deleteCheck = await asyncRollCheck(3);
    if (deleteCheck) {
      return;
    }
    console.log("row>>", row);
    let id = row.PURCH_INVOICE_ID;
    let type = "PUR";
    let jr_id = row.JOURNAL_ID;
    let billDate = row.PURCH_INVOICE_DATE;
    billDate = moment(billDate).format("YYYY-MM-DD");
    const master_sub_inv_id = row.master_sub_inv_id;
    let { userIp, userCountry } = await getUserIp();
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoadingResponse(true);

        axios
          .post(
            `${baseurl}/masterData/deleteMoneyOutOverViewID`,
            {
              DeleteId: id,
              invoice_date: billDate,
              type: type,
              journalId: jr_id,
              username: username,
              companyId: companyId,
              branchLov: master_sub_inv_id || null,
            },
            {
              headers: {
                authorization: token,
              },
            },
          )
          .then((response) => {
            let resMessage = response.data.message;

            setLoadingResponse(false);
            let resDate = response.data.resDate;

            let itemCode = response.data.itemCode;
            if (resMessage == "Negavtive Item") {
              swal({
                title: `Item of code ${itemCode} is being negetive on ${resDate}`,
                text: "issue",
                icon: "error",
              });

              // thisContex.toggle();
            } else if (response.data.message === "success") {
              Swal.fire("Deleted!", "Your Record has been deleted.", "success");

              getData(fSubInv?.id);
            }
          })
          .catch((err) => {
            setLoadingResponse(false);
            console.log(err);
            swal({
              title: "Failed!",
              text: "Internet Problem",
              icon: "error",
              size: "md",
              button: "Try Again!",
            });
          });
      }
    });
  };
  function orderDetHandler(cell, row) {
    return (
      <div>
        <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            // color="primary"
            // onClick={() => redirectToForm(row, 1)}
            onClick={() => addPropToggle(row, 1)}
          >
            <i className="fa fa-eye"></i>
          </Button>
        </span>
        {/* <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="warning"
            onClick={() => redirectToForm(row, 1, 1)}
          >
            Attach
          </Button>
        </span> */}
        {/* <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="success"
            onClick={() => redirectToForm(row, 2)}
            // onClick={blocked}
          >
            Edit
          </Button>
        </span> */}
        <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="danger"
            onClick={() => setDelete(row)}
          >
            <i className="fa fa-trash "></i>
          </Button>
        </span>
      </div>
    );
  }

const options = {
  paginationShowsTotal: true,
  page: 1,
  sizePerPage: 40, 
  pageStartIndex: 1,
  paginationSize: 5,
  prePage: "Prev",
  nextPage: "Next",
  firstPage: "First",
  lastPage: "Last",
  paginationPosition: "top",

  sizePerPageList: [
    { text: "10", value: 10 },
    { text: "30", value: 30 },
    { text: "40", value: 40 }, 
    { text: "50", value: 50 },
    { text: "100", value: 100 },
    { text: "All", value: table.OverViewDataTable?.length },
  ],
};

  return (
    <>
      {loadingResponse ? (
        <Responseloader />
      ) : (
        <div className="container-fluid bg-white">
          <div className="row">
            <div className="col-md-8 h3 p-3">Branch Transfer Invoices</div> 
          </div>
          <div className="row">
            <div className="col-md-3" style={{ marginBottom: "12px" }}>
              <Label style={{ fontWeight: "bold" }}>Branch :</Label>
              <Select
                // isClearable
                value={fSubInv || ""}
                options={subInvLov}
                onChange={(e) => handleFromChangeOpen(e)}
                name="subInv"
                placeholder={"-- Select --"}
              />
            </div>
            <ReactDatePicker
                              label="From Date:"
                              className="col-md-3  col-lg-3 col-xl-3 col-3"
                              isSelected={fDate}
                              onChange={(e) => {
                                setFDate(e);
                              }} 
                      dateFormat="dd-MMM-yyyy"
                              maxDate={tDate}
                            />
            <ReactDatePicker
                  label="To Date:"
                  className="col-md-3  col-lg-3 col-xl-3 col-3"
                  isSelected={tDate}
                      dateFormat="dd-MMM-yyyy"
                  onChange={(e) => {
                    setTDate( e );
                  }} 
                  minDate={fDate}
                />
            <div className="col-md-3 mt-4" style={{ marginBottom: "12px" }}>
               
                           <Button
                             type="button"
                             color="warning"
                             onClick={() => getData(fSubInv?.id)}
                             disabled={!fSubInv?.id}
                           >
                             Find
                           </Button>

  <Button
    type="button"
    color="success"
    style={{ marginLeft: "8px" }}
    onClick={exportToExcel}
    disabled={!table.OverViewDataTable || table.OverViewDataTable.length === 0}
  >
    Exp.Excel
  </Button>

  <Button
    type="button"
    color="danger"
    style={{ marginLeft: "8px" }}
    onClick={exportToPDF}
    disabled={!table.OverViewDataTable || table.OverViewDataTable.length === 0}
  >
    Exp.PDF
  </Button>
            </div>
          </div>
          <div translate="no" className="">
            <BootstrapTable
              data={table.OverViewDataTable}
              striped
              pagination
              hover
              search
              tableHeaderClass="rpr_header"
              tableBodyClass="rpr_body"
              containerClass="rpr_container"
              options={options}
            >
              <TableHeaderColumn dataAlign="center" row="0" colSpan="4">
                Purchase
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="DOCUMENT_NO"
                dataAlign="left"
                width="5%"
                className="rpr_header"
                row="1"
              >
                NO
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="received_Qty"
                dataAlign="right"
                width="6%"
                className="rpr_header"
                row="1"
              >
                Qty
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="AMOUNT"
                dataAlign="right"
                width="8%"
                className="rpr_header"
                row="1"
                dataFormat={dueformatter}
              >
                Amount
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="purch_formatted_date"
                dataAlign="left"
                width="8%"
                className="rpr_header"
                row="1"
              >
                Date
              </TableHeaderColumn>

              {/* ================= SALE / TRANSFER ================= */}
              <TableHeaderColumn dataAlign="center" row="0" colSpan="4">
                Transfer Invoice
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="inv_doc"
                dataAlign="left"
                width="5%"
                className="rpr_header"
                row="1"
              >
                Invoice No
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="inv_total_qty"
                dataAlign="right"
                width="6%"
                className="rpr_header"
                row="1"
              >
                Qty
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="inv_total_amount"
                dataAlign="right"
                width="8%"
                className="rpr_header"
                row="1"
                dataFormat={dueformatter}
              >
                Amount
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="inv_formatted_date"
                dataAlign="left"
                width="8%"
                className="rpr_header"
                row="1"
              >
                Date
              </TableHeaderColumn>

              {/* ================= COMMON ================= */}
              <TableHeaderColumn
                dataField="branch_desc"
                dataAlign="center"
                width="12%"
                row="0"
                rowSpan="2"
                dataSort
                isKey
              >
                From Branch
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="to_branch_desc"
                dataAlign="center"
                width="12%"
                row="0"
                rowSpan="2"
                dataSort
              >
                To Branch
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="received_Qty"
                row="0"
                rowSpan="2"
                dataAlign="center"
                width="8%"
                dataSort
              >
                Received Qty
              </TableHeaderColumn>

              <TableHeaderColumn
                dataAlign="center"
                dataField="dept_id"
                row="0"
                rowSpan="2"
                width="22%"
                dataFormat={orderDetHandler}
                className="rpr_header"
              >
                Action
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
      )}
      {showPurchaseModal ? (
        <PurchasereceiptModal toggle={addPropToggle} purchaseId={purchaseId} />
      ) : null}
    </>
  );
}